import { AvatarProfile } from "components/AvatarProfile";
import { TwitterIcon } from "components/library/Icons";
import { classNames } from "components/library/utils/classNames";
import React from "react";

const testimonials: TestimonialCardProps[] = [
  // {
  //   name: "Marc Falk",
  //   company: "CTO at REIQ",
  //   image: "/assets/customers/marc-reiq.jpeg",
  //   quote:
  //     "Download Programmatic and install it on your local machine via the command line. Spin up a new project and follow the testimonials to import your data.",
  // },

  // {
  //   name: "Victor Urano Braga",
  //   company: "CSO at Pluggy (YC S21)",
  //   image: "/assets/customers/victor-pluggy.jpeg",
  //   // TODO: made up. Get a genuine quote!
  //   quote:
  //     "Programmatic is a so useful for us to label thousands of transations a day. We couldn't do without it.",
  // },
  {
    name: "Henry Maguire",
    company: "DS at Orbital Witness",
    image: "/assets/customers/henry_maguire.jpeg",
    href: "https://twitter.com/hejmaguire/status/1500960472195125252?s=20&t=d-ZQ6OQCJEY8TcIQxbtCPA",
    quote: (
      <p>
        Programmatic is phenemonal! I think it&apos;s hard to justify NOT using
        this as a jumping off point for most NLP projects.
      </p>
    ),
  },
  {
    name: "Jonathan Bourne",
    company: "PhD Researcher at UCL",
    image: "/assets/customers/jonathan-bourne.jpeg",
    href: "https://twitter.com/sse_data/status/1499802971458215947",
    quote: (
      <p>
        Programmatic does&apos;t just make projects easier. It makes projects
        that were impossible straightforward and easy to understand. Pure 🔥🔥🔥
      </p>
    ),
  },
  {
    name: "Paul Simmering",
    company: "Data Scientist at Q",
    image: "/assets/customers/paul-simmering.jpeg",
    href: "https://twitter.com/paul_simmering/status/1499737687053549576",
    quote: (
      <>
        Thank you{" "}
        <a
          className="text-blue-600 no-underline hover:underline"
          target="_blank"
          rel="noreferrer"
          href="https://twitter.com/humanloop"
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          @humanloop
        </a>{" "}
        for letting me test Programmatic! It&apos;s cool to see a glimpse of
        next generation labeling for NLP.
      </>
    ),
  },
  {
    name: "Bram van Es",
    company: "Researcher at UMCU",
    image: "/assets/customers/bram.jpeg",
    href: "https://twitter.com/bramiozo/status/1500836959429840896?s=20&t=d-ZQ6OQCJEY8TcIQxbtCPA",
    quote: (
      <>
        <p>Human in the loop is the future of machine learning. </p>
        <p>
          Using #programmatic from{" "}
          <a
            className="text-blue-600 no-underline hover:underline"
            target="_blank"
            rel="noreferrer"
            href="https://twitter.com/humanloop"
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            @humanloop
          </a>{" "}
          now!
        </p>
      </>
    ),
  },
  {
    name: "Craig Pfeifer",
    company: "ML Engineer, ex-Mitre",
    image: "/assets/customers/craig-pfeifer.jpeg",
    href: "https://www.linkedin.com/feed/update/urn:li:activity:6945117473994137600",
    quote: (
      <>
        <p>
        I&apos;ve been using Programmatic for a month and it is the easiest, fastest way to annotate text. It is even appropriate for sensitive text as it runs 100% local.
        </p>
      </>
    ),
  },
  {
    name: "Federico Miras",
    company: "CEO at Pluggy (YC S21)",
    image: "/assets/customers/federico-pluggy.jpg",
    href: "https://twitter.com/fefomiras/status/1509529837605515264",
    quote: (
      <>
        <p>
          Programmatic{" "}
          <a
            className="text-blue-600 no-underline hover:underline"
            target="_blank"
            rel="noreferrer"
            href="https://twitter.com/humanloop"
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            @humanloop
          </a>{" "}
          is the way to go for NLP projects.
        </p>
        <p>
          This is literally how I imagined humans working with AI, actively
          interacting with data and having instant feedback
        </p>
      </>
    ),
  },
  {
    name: "Sam Hardy",
    company: "Deep Learning at Eliiza",
    image: "/assets/customers/samhardy.jpeg",
    href: "https://twitter.com/samhardyhey/status/1523987954527793152",
    quote: (
      <>
        <p>
          Have recently been tyre-kicking Programmatic by
          <a
            className="text-blue-600 no-underline hover:underline"
            target="_blank"
            rel="noreferrer"
            href="https://twitter.com/humanloop"
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            @humanloop
          </a>{" "}
          ; an annotation tool that significantly improves cold-start NLP
          (classification/NER) projects.
        </p>
        <p>Programmatic is the way to go for NLP projects.</p>
      </>
    ),
  },
  {
    name: "Had Seddiqi",
    company: "Director of ML at Ontra",
    image: "/assets/customers/had-seddiqi.jpeg",
    href: "https://twitter.com/HoddieOt/status/1522732405655687168",
    quote: (
      <>
        <p>
          been messing around with a programmatic labeling tool by{" "}
          <a
            className="text-blue-600 no-underline hover:underline"
            target="_blank"
            rel="noreferrer"
            href="https://twitter.com/humanloop"
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            @humanloop
          </a>{" "}
        </p>
        <p>
          ... its the pinnacle of tools when they can educate us to work and be
          smarter
        </p>
      </>
    ),
  },
];

interface TestimonialCardProps {
  name: string;
  company: string;
  href?: string;
  image: string;
  quote: string | JSX.Element;
}

const TestimonialCard = ({
  name,
  company,
  href,
  image,
  quote,
}: TestimonialCardProps): JSX.Element => {
  return (
    <div
      onClick={() => {
        window.open(href, "_blank");
      }}
      className={classNames(
        "cursor-pointer",
        "flex w-full max-w-full flex-col justify-between gap-24 rounded border border-gray-300 p-24",
        href ? "hover:border-gray-400 hover:bg-gray-100" : ""
      )}
    >
      <span className="prose max-w-prose text-16-24 text-gray-800">
        {quote}
      </span>
      <div className="mb-2 flex items-center justify-between gap-x-24">
        <AvatarProfile name={name} image={image} company={company} />
        <div>
          <TwitterIcon color="#009ef7" />
        </div>
      </div>
    </div>
  );
};

export const TestimonialsSection = () => {
  return (
    <div className="container-lg">
      <h3 className="mb-40 text-center font-display text-32-40 ">
        What others say
      </h3>
      <div className="lg:grid-3 grid-1 md:justify-items-none mb-140 justify-items-center gap-24">
        {testimonials.map((testimonial) => (
          <TestimonialCard key={testimonial.name} {...testimonial} />
        ))}
      </div>
    </div>
  );
};
